<!--
# Module: 基础数据管理
-->
<template>
  <div
    class="manage-page"
    v-loading="loading"
    element-loading-spinner="el-icon-loading"
    element-loading-text="拼命处理中..."
  >
    <div class="page-view">
      <div class="item-row" v-for="nav in navMenu" :key="nav.id">
        <div class="name" @click="handleNavMenuSelect(nav.id)">
          <span>{{nav.title}}</span>
        </div>
        <p class="tips">{{nav.dec}}</p>
      </div>
    </div>
    <common-dialog
      append-to-body
      v-if="dialogVisible"
      :title="dialogOptions.title"
      :width="dialogOptions.width"
      :height="dialogOptions.height"
      :visible.sync="dialogVisible"
      cover
    >
      <userinfo-change-form @successThen="successThen" @cancel="dialogVisible=false"></userinfo-change-form>
    </common-dialog>
  </div>
</template>

<script>
import userinfoChangeForm from '@/components/applyForm/userinfoChangeForm.vue'
export default {
  name: 'basicsManage',
  data () {
    return {
      loading: false, // loading
      dialogOptions: {
        title: '',
        width: '600px',
        height: ''
      },
      dialogVisible: false, // 弹窗是否显示
      formId: '' // 表单ID
    }
  },
  components: {
    userinfoChangeForm
  },
  computed: {
    // 选项卡：菜单导航
    navMenu () {
      return [
        { id: 'Userinfo_Change', title: '变更信息申请', dec: '变更基础信息，包括计划户地址、联系人、联系电话' }
      ]
    },
    // 表单：字段定义(变更信息)
    userFields () {
      return {
        code: '单位编码',
        name: '单位名称',
        contact_man: '联系人',
        contact_phone: '联系电话',
        addr_id: '地址',
        addr_detail: '详细地址',
        postal_code: '邮政编码',
        is_mainuser: '是否为重点用户',
        usewater_id: '用水性质',
        usewater_price: '用水单价',
        green_area: '绿化面积'
      }
    }
  },
  mounted () {
  },
  methods: {
    // 功能：控制菜单选择
    handleNavMenuSelect (formId) {
      var _userInfo = this.$store.state.userInfo
      this.dialogVisible = true

      this.$nextTick(() => {
        if (this.$refs.JuserInfoForm) {
          this.$refs.JuserInfoForm.resetFields()
        }
      })
      switch (formId) {
        case 'Userinfo_Change': // 变更信息申请
          this.dialogOptions = {
            title: '变更信息申请',
            width: '600px',
            height: ''
          }
          break
      }
      this.formId = formId
    },
    successThen () {
      setTimeout(() => {
        this.dialogVisible = false
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  margin-top: 25px;
  text-align: right;
}

.dialog-table {
  margin-top: 10px;
  margin-bottom: 25px;
  height: 230px;
}

.dialog-formBox {
  width: 560px;
  margin: 0 auto;
}
</style>